import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconFileImportSvg } from "./IconFileImportSvg.mjs";
const IconFileImport = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconFileImportSvg, ...iconProps });
};
export {
  IconFileImport
};
